import Dashboard from "views/Dashboard/Dashboard.jsx";
import UserProfile from "views/UserProfile.jsx";
import Pan from "views/Pan/Pan.jsx";
import EmployeeList from "views/Employee/EmployeeList.jsx";
import UserList from "views/User/UserList.jsx";
import Form from "views/Form/Form.jsx";
import DatabaseList from "views/Database/DatabaseList/DatabaseList.jsx";
import Payroll from "views/Payroll/Payroll.jsx";
import Report from "views/Report/Report.jsx";

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "pe-7s-graph",
    component: Dashboard
  },
  {
    path: "/profile",
    name: "Profile",
    icon: "pe-7s-user",
    component: UserProfile
  },
  {
    path: "/pan",
    name: "PAN",
    icon: "pe-7s-add-user",
    component: Pan
  },
  {
    path: "/employees/list",
    name: "Employees",
    icon: "pe-7s-users",
    component: EmployeeList
  },
  {
    path: "/users/list",
    name: "Users",
    icon: "pe-7s-users",
    component: UserList
  },
  {
    path: "/forms",
    name: "Forms",
    icon: "pe-7s-note2",
    component: Form
  },
  {
    path: "/database/list",
    name: "Database",
    icon: "pe-7s-server",
    component: DatabaseList
  },
  /*
  // TODO: Uncomment GeneralMemoList when it's integrated with API
  {
    path: "/general-memos/list",
    name: "General Memos",
    icon: "pe-7s-mail-open-file",
    component: GeneralMemoList
  },
  */
  {
    path: "/payroll",
    name: "Payroll",
    icon: "pe-7s-cash",
    component: Payroll
  },
  {
    path: "/report",
    name: "Report",
    icon: "pe-7s-display2",
    component: Report
  }
];

export default dashboardRoutes;
